import { useDispatch } from 'react-redux';

import { changeUserProject } from 'core/userContext';

/**
 * React hook that returns a Redux-bound callback function for fetching a new
 * session cookie for a given project ID via an XHR. The session cookie is
 * HTTP-only, so it is not returned to the caller. Instead, the retrieved session
 * cookie is attached to all subsequent API requests by the browser.
 *
 * Please note: the callback produced by this hook does not reload the page
 * once the new cookie is retreived.
 */
export const useFetchSessionCookieForOtherProject = () => {
  const dispatch = useDispatch();
  return (projectId: number) =>
    new Promise<void>((resolve) => {
      dispatch(changeUserProject(projectId, { onComplete: resolve, reloadPageOnComplete: false }));
    });
};
